"use client";

import styled from "styled-components";
import { ButtonGameRegular } from "@/components/ui/buttons/button-game-regular";
import { redirect } from "next/navigation";
import { LoginRoutes } from "../../routes";
import ChefsDraw from "@/components/icons/ChefsDraw";

/**
 * Styled Components
 */

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.Colors.yellow500};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 320px;
  width: 100%;
  height: 100%;
  padding: 0 20px;
`;

const CircleImageContainer = styled.div`
  margin: 20px 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoginTitle = styled.h2`
  margin: 20px 0 30px;
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.Colors.black};
  text-align: center;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  width: 100%;
`;

/**
 * Login Client Props
 */
interface LoginClientProps {
  slug: string;
}

/**
 * Login Client Component
 */
export const LoginClient = ({ slug }: LoginClientProps) => {
  const handleLoginCookUnity = () => {
    const baseUrl = process.env.NEXT_PUBLIC_EXTERNAL_ENTRY_POINT;
    if (baseUrl) {
      const url = new URL(baseUrl);
      url.searchParams.set('slug', slug);
      const externalEntryPoint = url.toString();
      
      if (typeof window !== "undefined") {
        if (window.parent) {
          window.parent.location.href = externalEntryPoint;
        } else {
          window.location.href = externalEntryPoint;
        }
      }
    } else {
      console.error("NEXT_PUBLIC_EXTERNAL_ENTRY_POINT is not defined");
    }
  };

  const handleLoginAsAGuest = () => {
    redirect(LoginRoutes.LOGIN_GUEST.replace("{slug}", slug));
  };

  return (
    <PageWrapper>
      <ContentContainer>
        <CircleImageContainer>
          <div data-testid="chefs-draw-icon" style={{ width: "180px", height: "180px" }}>
            <ChefsDraw width={180} height={180} />
          </div>
        </CircleImageContainer>

        <LoginTitle>Log in to start playing</LoginTitle>

        <ButtonsContainer>
          <ButtonWrapper>
            <ButtonGameRegular
              text="Log in with CookUnity"
              color="black"
              borderColor="white"
              onClick={handleLoginCookUnity}
              data-testid="cook-unity-button"
            />
          </ButtonWrapper>
          <ButtonWrapper>
            <ButtonGameRegular
              text="Log in as a guest"
              color="white"
              borderColor="gray200"
              textColor="black"
              onClick={handleLoginAsAGuest}
              data-testid="guest-button"
            />
          </ButtonWrapper>
        </ButtonsContainer>
      </ContentContainer>
    </PageWrapper>
  );
};
